import BallotIcon from '@material-ui/icons/Ballot';
import AddButton from '../../core/AddButton';
import DateFnsUtils from '@date-io/date-fns';
import { Typography } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import { withStyles } from '@material-ui/core/styles';
import { KeyboardDatePicker, KeyboardDateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import 'date-fns';
import PropTypes from 'prop-types';
import React from 'react';
import Datatype from '../../core/Datatype';
import DialogMultiActions from '../../core/DialogMultiActions';
import Errored from '../../core/Errored';
import Help from '../../core/Help';
import LabelledSwitch from '../../core/LabelledSwitch';
import MenuSelector from '../../core/MenuSelector';
import Notification from '../../core/Notification';
import PrimaryButton from '../../core/PrimaryButton';
import ProjectLanguageSelector from '../../core/ProjectLanguageSelector';
import SearchDropDown from '../../core/SearchDropDown';
import SecondaryButton from '../../core/SecondaryButton';
import { globalStyles as styles } from '../../core/style/gstheme';
import TitledPanel from '../../core/TitledPanel';
import TitledTextField from '../../core/TitledTextField';
import { DATATYPES, DATATYPE_LIMITS, MAX_DEFINITION_LENGTH } from '../../core/utils/constants';
import { checkValidity, getGraphFromProject, lightSanitiseText, makeCancelable, sanitiseText } from '../../core/utils/utils';
import GS from '../../grafsync/grafsync';
import ConceptChip from '../core/ConceptChip';
import FindOntologyRelatedConcept from '../taxonomies/FindOntologyRelatedConcept';

const noteProps = ["changeNote", "editorialNote", "historyNote", "scopeNote"];

const ADD_ACTION = "add";
const REMOVE_ACTION = "remove";
const REMOVE_ALL_ACTION = "removeAll";
const REPLACE_ACTION = "replace";

const loadOptions = {
    predicates: [
        "http://www.w3.org/2004/02/skos/core#prefLabel",
        "http://www.w3.org/2008/05/skos-xl#prefLabel"
    ],
    tests: [
        {
            id: "http://www.w3.org/2008/05/skos-xl#prefLabel",
            join: [{
                predicate: "http://www.w3.org/2008/05/skos-xl#literalForm"
            }]
        }
    ]
};

class EditDataDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            isLoading: true,
            checked: false,
            actionResource: "",
            associatedGraphs: [],
            customProp: "",
            customValue: "",
            inferredClassList: [],
            date: Date.now(),
            customRange: "",
            isErrored: null,
            error: false,
            invalid: true,
            customType: [],
            previewNotAvailable: false,
            propertyLang: props.defaultLang,
            lang: props.defaultLang,
            classType: "",
            text: "",
            actionType: ADD_ACTION
        };
        this.cancellable = null;
    }

    loadData(iriData, options) {
        this.cancellable = makeCancelable(GS.loadDataFromGraph(iriData, options));
        return this.cancellable;
    }

    loadBasicData(iriList, options) {
        this.cancellable = makeCancelable(GS.loadData(iriList, options, this.props.graph));
        return this.cancellable;
    }

    componentWillUnmount() {
        if (this.cancellable) this.cancellable.cancel();
    }

    collectResourceData = async () => {
        try {
            GS.handle("collect-resource-data");
            if (!this.props.ontologyProjectAssociation || this.props.ontologyProjectAssociation.length === 0) {
                this.setState({ isLoading: false });
                return;
            }
            // We load association resources (these are in the project graph)
            const opaLoadData = this.props.ontologyProjectAssociation.map(opa => ({
                graph: this.props.graph,
                iri: opa
            }));
            await this.loadData(opaLoadData, {}).promise;
            if (this.cancellable && this.cancellable.isCancelled()) return;
            // We get all the association information
            const opaSet = this.props.ontologyProjectAssociation
                .filter(opa => GS.isLoaded(opa, this.props.graph))
                .map(opa => GS.data(opa, this.props.graph));
            // There is an edge case where the same IRI is in two ontologies but totally unlikely
            let associatedGraphs = opaSet.map(opa => getGraphFromProject(opa.associatedProject));
            this.setState({ associatedGraphs });
        }
        catch (e) {
            if (!this.cancellable || (this.cancellable && !this.cancellable.isCancelled())) this.setState({ isErrored: e });
        }
    };

    handleClickOpen = () => {
        this.setState({
            open: true,
            checked: false,
            actionResource: "",
            classType: "",
            text: "",
            associatedGraphs: [],
            customValue: "",
            customType: [],
            inferredClassList: [],
            summary: [],
            date: Date.now(),
            customProp: "",
            customRange: "",
            error: false,
            summaryComplete: true,
            propertyLang: this.props.defaultLang,
            lang: this.props.defaultLang,
            processing: false,
            actionType: ADD_ACTION
        }, () => this.collectResourceData());
    };

    exitEditData = () => this.setState({ open: false });

    handleChangeActionType = event => {
        const t = event.target;
        this.setState({
            actionResource: "",
            classType: "",
            customType: [],
            previewNotAvailable: t.value === REMOVE_ALL_ACTION,
            date: Date.now(),
            inferredClassList: [],
            summaryComplete: false,
            summary: [],
            customProp: "",
            customRange: "",
            text: "",
            actionType: t.value,
            invalid: true
        });
    };

    handleChangeActionResource = actionResource => this.setState({
        actionResource,
        classType: "",
        customType: [],
        date: Date.now(),
        customProp: "",
        customRange: "",
        summary: [],
        summaryComplete: false,
        inferredClassList: [],
        text: "",
        error: false,
        invalid: actionResource === "deprecate" ?
            false
            :
            this.state.actionType === REMOVE_ALL_ACTION && actionResource !== "customProp" ?
                false
                :
                true
    });

    handleClassChange = (classType) => this.setState({
        classType,
        summary: [],
        summaryComplete: false,
        invalid: false
    });

    handleBooleanChange = (checked) => this.setState({
        checked,
        invalid: false,
        summary: [],
        summaryComplete: false,
        customValue: checked.toString()
    });

    convertDate = (date) => {
        const value =
            date.getFullYear() + "-" +
            ("0" + (date.getMonth() + 1)).slice(-2) + "-" +
            ("0" + date.getDate()).slice(-2);
        return value;
    };

    handleDateChange = (data) => {
        if (data === null) {
            this.setState({ customValue: "", invalid: true, date: data });
            return;
        }
        const tempDate = new Date(data);
        if (tempDate.toString() === "Invalid Date") {
            this.setState({ customValue: "", invalid: true, date: data });
            return;
        }
        const customValue = this.convertDate(tempDate);
        this.setState({
            customValue,
            invalid: false,
            date: data,
            summary: [],
            summaryComplete: false
        });
    };

    handleDatetimeChange = (data) => {
        if (isNaN(Date.parse(data))) {
            this.setState({ customValue: "", invalid: true, date: data });
            return;
        }
        const tempDate = new Date(data);
        const customValue = tempDate.toISOString();
        this.setState({
            customValue, invalid: false,
            date: data,
            summary: [],
            summaryComplete: false
        });
    };

    onIncludeResource = (iri) => this.setState({ customValue: iri, invalid: false, summaryComplete: false });

    selectDataLanguage = (lang) => this.setState({ lang, summaryComplete: false });

    changePropertyLanguage = (propertyLang) => this.setState({ propertyLang });

    handleChange = event => {
        const t = event.target;
        const cleanText = lightSanitiseText(t.value.trimLeft());
        const invalid = cleanText.trim() === "";
        this.setState({
            [t.name]: cleanText,
            invalid,
            summary: [],
            summaryComplete: false,
        });
    };

    handleLiteralChange = (event) => {
        const t = event.target;
        const cleanText = sanitiseText(t.value.trimLeft());
        const invalid = cleanText.trim() === "";
        this.setState({
            text: cleanText,
            invalid,
            summary: [],
            summaryComplete: false,
            customValue: cleanText.trim()
        }, this.checkLiteralValidity);
    };

    checkLiteralValidity() {
        const { customRange, text } = this.state;
        if (text.trim() === "") {
            this.setState({ error: false });
            return;
        }
        let validity = checkValidity(text.trim(), customRange, [], MAX_DEFINITION_LENGTH);
        this.setState({ error: !validity.isValid });
    }

    clearError = async () => {
        this.setState({ isErrored: false }, () => this.exitEditData());
    };

    runOperation(isSummary = false) {
        let property = "";
        let value = "";
        let datatype = "";
        let lang;
        let propertyGraph;
        const { actionResource, customType, customRange, actionType } = this.state;
        if (actionResource === "editClass") {
            property = "http://www.w3.org/1999/02/22-rdf-syntax-ns#type";
            value = this.state.classType;
        }
        else if (actionResource === "deprecate") {
            property = "http://www.w3.org/2002/07/owl#deprecated";
            value = "true";
            datatype = "http://www.w3.org/2001/XMLSchema#boolean";
        }
        else if (actionResource === "customProp") {
            property = this.state.customProp;
            value = this.state.customValue;
            propertyGraph = this.state.customPropertyGraph;
            if (!customType.includes("ObjectProperty")) {
                lang = customRange === DATATYPES.LANGSTRING ?
                    this.state.lang
                    :
                    null;
                datatype = customRange === DATATYPES.LANGSTRING ?
                    null
                    :
                    customRange;
            }
        }
        else {
            property = "http://www.w3.org/2004/02/skos/core#" + actionResource;
            value = this.state.text;
            lang = this.state.lang;
        }
        const operation = actionType === ADD_ACTION ?
            this.props.operationAdd
            :
            actionType === REPLACE_ACTION ?
                this.props.operationReplace
                :
                actionType === REMOVE_ALL_ACTION ?
                    this.props.operationRemoveAll
                    :
                    this.props.operationRemove;
        const payload = {
            action: operation,
            property,
            value,
            ...(this.props.resourceList) && { resourceList: this.props.resourceList },
            ...(propertyGraph) && { propertyGraph },
            ...(datatype) && { datatype },
            ...(lang === "und") && { datatype: DATATYPES.STRING },
            ...(lang && lang !== "und") && { lang }
        };
        if (isSummary) {
            return GS.operationSummary("batchupdate", this.props.graph, payload);
        }
        return GS.operate("batchupdate", this.props.graph, payload);
    }

    getSummary = () => {
        this.setState({ processing: true, summaryComplete: false }, async () => {
            try {
                const summaryData = await this.runOperation(true);
                const summary = await summaryData.json();
                const summaryMessages = [...new Set(summary.map(item => item.message))].sort();
                const summaryResources = [...new Set(summary.map(item => item.resource))];
                await this.loadBasicData(summaryResources, loadOptions).promise;
                if (this.cancellable && this.cancellable.isCancelled()) return;
                this.setState({ summary, summaryMessages, summaryComplete: true, processing: false });
            }
            catch (e) {
                if (!this.cancellable || (this.cancellable && !this.cancellable.isCancelled())) {
                    this.setState({ isErrored: { message: "Cannot get summary." } });
                }
            }
        });
    };

    runChange = () => {
        this.setState({ processing: true }, async () => {
            try {
                // We need to ensure messages are processed or batch lock will cause rejection
                await GS.waitForEditsToClear();
                await this.runOperation();
            }
            catch (e) {
                if (!this.cancellable || (this.cancellable && !this.cancellable.isCancelled())) {
                    this.setState({ isErrored: { message: "Cannot perform bulk change." } });
                }
            }
        });
    };

    onFoundProp = (customProp, customData) => {
        const customType = Array.isArray(customData.type) ? [...customData.type] : [customData.type];
        let range = customData.range && customData.range.length > 0 ? customData.range[0] : "";
        if ((range === "" || range === "http://www.w3.org/2000/01/rdf-schema#Literal")
            && (customType.includes("DatatypeProperty") || customType.includes("AnnotationProperty"))) {
            range = DATATYPES.STRING;
        }
        const propertyGraph = customData.inNamedGraph;
        const invalid = this.state.actionType === REMOVE_ALL_ACTION || range === DATATYPES.BOOLEAN
            || range === DATATYPES.DATE || range === DATATYPES.DATETIME ?
            false
            :
            true;
        const inferredClassList = GS.getSubclasses(range, propertyGraph);
        const tempDate = new Date(Date.now());
        const customValue = range === DATATYPES.DATE ?
            this.convertDate(tempDate)
            :
            range === DATATYPES.DATETIME ?
                tempDate.toISOString()
                :
                range === DATATYPES.BOOLEAN ?
                    false
                    :
                    "";
        this.setState({
            customProp,
            customType,
            customRange: range,
            inferredClassList,
            customPropertyGraph: propertyGraph,
            invalid,
            summary: [],
            summaryComplete: false,
            date: Date.now(),
            text: "",
            customValue
        });
    };

    resetProperty = () => {
        this.setState({ customProp: "", customType: [], customRange: "", invalid: true, text: "", customValue: "" });
    };

    computeSearch = (value, lang) => {
        let search = [
            {
                predicate: "http://www.w3.org/1999/02/22-rdf-syntax-ns#type",
                value: [
                    "http://www.w3.org/2002/07/owl#ObjectProperty",
                    "http://www.w3.org/2002/07/owl#AnnotationProperty",
                    "http://www.w3.org/2002/07/owl#DatatypeProperty"
                ]
            }
        ];
        if (value !== "") {
            search.push({
                predicate: "http://www.w3.org/2000/01/rdf-schema#label",
                value: value,
                isExactMatch: false
            });
        }
        else {
            search.push({
                predicate: "http://www.w3.org/2000/01/rdf-schema#label"
            });
        }
        let fullSearch =
        {
            search,
            graph: this.state.associatedGraphs,
            exclude: [
                "https://graphifi.com/schema/xowl/topAnnotationProperty",
                "http://www.w3.org/2002/07/owl#topObjectProperty",
                "http://www.w3.org/2002/07/owl#topDataProperty"
            ],
            language: lang,
            ignoreNoLanguage: lang !== "und",
            pageSize: 100,
            predicates: [
                "http://www.w3.org/2000/01/rdf-schema#label",
                "http://www.w3.org/2002/07/owl#deprecated",
                "http://www.w3.org/2000/01/rdf-schema#domain",
                "http://www.w3.org/2000/01/rdf-schema#range",
                "http://www.w3.org/1999/02/22-rdf-syntax-ns#type"
            ],
            sort: "http://www.w3.org/2000/01/rdf-schema#label"
        };
        return fullSearch;
    };

    computeOptions = () => {
        const { actionType } = this.state;
        const actionPrepend = actionType === ADD_ACTION ?
            "Add"
            :
            actionType === REPLACE_ACTION ?
                "Replace every"
                :
                actionType === REMOVE_ALL_ACTION ?
                    "Remove any"
                    :
                    "Remove";
        let options = [];
        if (this.props.classList && this.props.classList.length > 0) {
            options.push({
                "value": "editClass",
                "label": actionPrepend + " Class"
            });
        }
        if (this.state.associatedGraphs && this.state.associatedGraphs.length > 0) {
            options.push({
                "value": "customProp",
                "label": actionPrepend + " Value or Relationship for a Property"
            });
        }
        if (actionType === REPLACE_ACTION || actionType === REMOVE_ALL_ACTION) {
            options.push({
                "value": "deprecate",
                "label": actionType === REPLACE_ACTION ? "Make Deprecated" : "Undeprecate"
            });
        }
        options = options.concat([
            {
                "value": "changeNote",
                "label": actionPrepend + " Change Note"
            },
            {
                "value": "editorialNote",
                "label": actionPrepend + " Editorial Note"
            },
            {
                "value": "historyNote",
                "label": actionPrepend + " History Note"
            },
            {
                "value": "scopeNote",
                "label": actionPrepend + " Scope Note"
            }
        ]);
        return options;
    };

    render() {

        const { classes, classList, defaultLang, graph, disabled, icon } = this.props;
        const { isErrored, actionType, actionResource, classType, customRange, error, checked, summaryComplete, previewNotAvailable,
            processing, text, lang, propertyLang, date, invalid, customType, inferredClassList, summary, summaryMessages } = this.state;

        if (isErrored) return <Errored dataTest="bulk-error" data={isErrored} clearError={this.clearError} />;

        let options = this.computeOptions();

        let dataAddComponent = null;

        if (actionType !== REMOVE_ALL_ACTION) {
            if (actionResource === "editClass") {
                dataAddComponent = <TitledPanel dataTest="select-class" title="Select a Class">
                    <div style={{ height: 40, overflow: 'visible' }}>
                        <MenuSelector
                            dataTest="class-selector"
                            showValues={true}
                            selected={classType}
                            handleChange={this.handleClassChange}
                            options={[
                                ...classList
                            ]} />
                    </div>
                </TitledPanel>;
            }
            else if (actionResource === "deprecate") {
                dataAddComponent = <Typography data-test="deprecation-message" variant="body2">This will make all resources deprecated.</Typography>;
            }
            else if (noteProps.includes(actionResource) || customRange === DATATYPES.LANGSTRING) {
                dataAddComponent = <div>
                    <TitledPanel dataTest="data-language-select" title="Language">
                        <ProjectLanguageSelector
                            selectedLang={lang}
                            includeLabel={false}
                            excludeNoLanguage={customRange === DATATYPES.LANGSTRING}
                            onSelect={this.selectDataLanguage} />
                    </TitledPanel>
                    <TitledTextField
                        dataTest="note-text"
                        name="text"
                        autoFocus={true}
                        title="Text"
                        margin={true}
                        placeholder="Please enter text"
                        required={true}
                        text={text}
                        multiline={customRange === DATATYPES.LANGSTRING ? false : true}
                        rows={9}
                        maxLength={customRange === DATATYPES.LANGSTRING ? 1000 : MAX_DEFINITION_LENGTH}
                        onChange={customRange === DATATYPES.LANGSTRING ? this.handleLiteralChange : this.handleChange} />
                </div>;
            }
            else if (customType.includes("ObjectProperty")) {
                dataAddComponent = <div style={{ backgroundColor: 'white', padding: 6, borderRadius: 4, marginBottom: 4 }}>
                    <FindOntologyRelatedConcept
                        searchClasses={customRange === "" ? inferredClassList : [customRange, ...inferredClassList]}
                        allowIRI={false}
                        height={342}
                        resetOnSelect={false}
                        singleValue={true}
                        selectedStyle={{
                            backgroundColor: 'white',
                            opacity: 1,
                            border: 'solid 1px black',
                            borderRadius: '4px'
                        }}
                        onIncludeResource={this.onIncludeResource}
                        allowEmpty={true}
                    />
                </div>;
            }
            else {
                const datatypeLimits = customRange === "" ? [] : DATATYPE_LIMITS[customRange];
                switch (customRange) {
                    case DATATYPES.DATE:
                        dataAddComponent = <TitledPanel title="Select a Date">
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDatePicker
                                    className={classes.datepicker}
                                    data-test="date-picker"
                                    inputProps={{
                                        "data-test": "date-picker-text"
                                    }}
                                    format="yyyy/MM/dd"
                                    margin="dense"
                                    id="date-picker-inline"
                                    value={date}
                                    inputVariant="outlined"
                                    onChange={this.handleDateChange}
                                    KeyboardButtonProps={{
                                        'aria-label': 'Select date',
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        </TitledPanel>;
                        break;
                    case DATATYPES.DATETIME:
                        dataAddComponent = <TitledPanel title="Select a Date and Time">
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                <KeyboardDateTimePicker
                                    data-test="datetime-picker"
                                    className={classes.datepicker}
                                    inputProps={{
                                        "data-test": "date-picker-text"
                                    }}
                                    variant="inline"
                                    format="yyyy/MM/dd HH:mm"
                                    margin="dense"
                                    id="date-picker-inline"
                                    inputVariant="outlined"
                                    value={date}
                                    onChange={this.handleDatetimeChange}
                                    KeyboardButtonProps={{
                                        'aria-label': 'Select date and time',
                                    }}
                                />
                            </MuiPickersUtilsProvider>
                        </TitledPanel>;
                        break;
                    case DATATYPES.BOOLEAN:
                        dataAddComponent =
                            <TitledPanel title="Select a Value">
                                <div style={{ display: 'flex' }}>
                                    <Typography className={classes.formLabel} style={{ marginTop: 18 }}>False</Typography>
                                    <LabelledSwitch
                                        dataTest="true-false"
                                        label="True"
                                        checked={checked}
                                        handleChange={this.handleBooleanChange}
                                    />
                                </div>
                            </TitledPanel>;
                        break;
                    case DATATYPES.STRING: case DATATYPES.ANYURI: case DATATYPES.INTEGER: case DATATYPES.DECIMAL: case DATATYPES.FLOAT: case DATATYPES.DOUBLE: case DATATYPES.LONG:
                        dataAddComponent = <TitledTextField
                            dataTest="typed-literal-input"
                            name="literal"
                            title="Text"
                            autoFocus={true}
                            required={true}
                            placeholder="Please enter text"
                            error={error}
                            text={text}
                            startAdornment={<Datatype datatype={customRange} />}
                            errorText={
                                error ?
                                    "The value is not valid for the range."
                                    :
                                    null
                            }
                            maxLength={datatypeLimits && datatypeLimits.maxLength ?
                                datatypeLimits.maxLength
                                :
                                1000}
                            onChange={this.handleLiteralChange} />;
                        break;
                    default:
                        break;
                }
            }
        }

        return (
            <React.Fragment>
                <AddButton color="secondary" disabled={disabled} icon={icon} dataTest="bulk-edit" title="Bulk change" onClick={this.handleClickOpen} />
                {this.state.open &&
                    <Dialog
                        data-test="bulk-change-dialog"
                        maxWidth="xl"
                        fullWidth
                        classes={{
                            paper: classes.paper,
                            paperWidthXl: classes.xLargeDialog
                        }}
                        open={this.state.open}
                        onClose={this.exitAddLabel}
                        aria-labelledby="bulk-change-dialog-title">
                        <DialogTitle data-test="bulk-change-dialog-title"
                            disableTypography
                            className={classes.mainHeading} id="bulk-change-dialog-title">Bulk Change</DialogTitle>
                        <DialogContent data-test="bulk-change-dialog"
                            style={{
                                height: '420px',
                                overflowY: 'visible'
                            }}>
                            <Help textRef="BULK_CHANGE" />
                            <form autoComplete="off" noValidate="novalidate">
                                <div style={{ display: 'flex' }}>
                                    <div style={{ flex: 0, width: 300 }}>
                                        <TitledPanel dataTest="type-of-action" title="Type of Change">
                                            <div style={{ width: 285 }}>
                                                <FormControl component="fieldset">
                                                    <RadioGroup row aria-label="Select ordered or unordered" name="orderType" value={actionType} onChange={this.handleChangeActionType}>
                                                        <div style={{ width: 120, marginLeft: 12 }}>
                                                            <FormControlLabel data-test="add-action" value={ADD_ACTION} control={<Radio color="primary" />} label="Add"
                                                                classes={{ label: classes.formLabelInline }}
                                                            />
                                                        </div>
                                                        <FormControlLabel data-test="replace-action" value={REPLACE_ACTION} control={<Radio color="primary" />} label="Replace"
                                                            classes={{ label: classes.formLabelInline }}
                                                        />
                                                        <div style={{ width: 120, marginLeft: 12 }}>
                                                            <FormControlLabel data-test="remove-action" value={REMOVE_ACTION} control={<Radio color="primary" />} label="Remove"
                                                                classes={{ label: classes.formLabelInline }}
                                                            />
                                                        </div>
                                                        <FormControlLabel data-test="remove-all-action" value={REMOVE_ALL_ACTION} control={<Radio color="primary" />} label="Remove All"
                                                            classes={{ label: classes.formLabelInline }}
                                                        />
                                                    </RadioGroup>
                                                </FormControl>
                                            </div>
                                        </TitledPanel>
                                        <TitledPanel margin dataTest="action-resource" title="Choose an Action">
                                            <MenuSelector
                                                key={actionType}
                                                autoFocus={false}
                                                dataTest="action-selector"
                                                selected={actionResource}
                                                handleChange={this.handleChangeActionResource}
                                                options={options} />
                                        </TitledPanel>
                                        {actionResource === "customProp" &&
                                            <TitledPanel
                                                dataTest="select-property"
                                                required={true}
                                                margin title="Property"
                                                overflow={true}>
                                                <ProjectLanguageSelector
                                                    selectedLang={lang}
                                                    includeLabel={true}
                                                    onSelect={this.changePropertyLanguage} />
                                                <div style={{ height: 40, marginTop: 12, overflow: 'visible' }}>
                                                    <SearchDropDown
                                                        dataTest="find-property"
                                                        search={this.computeSearch}
                                                        sortProp="label"
                                                        focus={true}
                                                        suppressMessages={true}
                                                        onHandleSelectionChange={this.resetProperty}
                                                        isClickableResult={(result) => {
                                                            if (actionType !== REPLACE_ACTION && result.range && result.range.includes("http://www.w3.org/2001/XMLSchema#boolean")) return false;
                                                            if (actionType !== REPLACE_ACTION && result.type && result.type.includes("FunctionalProperty")) return false;
                                                            if (result.range && result.range.includes("http://www.w3.org/2008/05/skos-xl#Label")) return false;
                                                            if (result.domain) {
                                                                if (result.domain.includes("http://www.w3.org/2008/05/skos-xl#Label")) return false;
                                                                if (result.domain.includes("http://www.w3.org/2004/02/skos/core#Collection")) return false;
                                                                if (result.domain.includes("http://www.w3.org/2004/02/skos/core#OrderedCollection")) return false;
                                                                if (result.domain.includes("http://www.w3.org/2004/02/skos/core#ConceptScheme")) return false;
                                                            }
                                                            return true;
                                                        }
                                                        }
                                                        listDisplay={(result, lang) => {
                                                            const domain = result.domain ? <span className={classes.domainRange}><span className={classes.drTitle}>Domain</span> {result.domain.join(", ")}</span> : null;
                                                            const range = result.range ? <span className={classes.domainRange}><span className={classes.drTitle}>Range</span> {result.range.join(", ")}</span> : null;
                                                            return <div data-test="result-label">
                                                                <Typography variant="body2">
                                                                    <span style={{ wordBreak: 'break-word' }}>
                                                                        {result.label && result.label[lang] ?
                                                                            Array.isArray(result.label[lang]) ?
                                                                                result.label[lang].sort().join(" AND ")
                                                                                :
                                                                                result.label[lang]
                                                                            :
                                                                            result.id
                                                                        }
                                                                    </span>
                                                                </Typography>
                                                                <div>{domain}{range}</div>
                                                                {actionType !== REPLACE_ACTION &&
                                                                    ((result.range && result.range.includes("http://www.w3.org/2001/XMLSchema#boolean"))
                                                                        || (result.type && result.type.includes("FunctionalProperty"))) &&
                                                                    <Typography variant="caption">Not available for the selected change type.</Typography>
                                                                }
                                                            </div>;
                                                        }
                                                        }
                                                        listSelectionDisplay={(result, lang) => {
                                                            if (result.label && result.label[lang]) {
                                                                return Array.isArray(result.label[lang]) ?
                                                                    result.label[lang][0]
                                                                    :
                                                                    result.label[lang];
                                                            }
                                                            else return "";
                                                        }}
                                                        title="Find a property"
                                                        lang={propertyLang}
                                                        chosen={this.onFoundProp} />
                                                </div>
                                            </TitledPanel>
                                        }
                                    </div>
                                    {dataAddComponent &&
                                        <div data-test="data-to-add" style={{ marginLeft: 12, width: 330, height: 388, backgroundColor: '#f5f5f5', padding: 12 }}>
                                            <Typography data-test="action-title" className={classes.subMainHeading}>{
                                                actionType === ADD_ACTION ?
                                                    "Data to Add"
                                                    :
                                                    actionType === REMOVE_ACTION ?
                                                        "Data to Remove"
                                                        :
                                                        "Replace With"
                                            }</Typography>
                                            {dataAddComponent}
                                        </div>
                                    }
                                    {!dataAddComponent &&
                                        <div data-test="summary" style={{ marginLeft: 12, width: 300, height: 388, overflow: 'scroll', backgroundColor: '#f5f5f5', padding: 12 }}>
                                            <Typography data-test="information-title" className={classes.subMainHeading}>Information</Typography>
                                            <div data-test="information-info">
                                                    <Typography paragraph variant="body2">Bulk changes do not affect the status of any resources in taxonomies with workflow activated.</Typography>
                                                </div>
                                        </div>
                                    }
                                    {dataAddComponent &&
                                        <div data-test="summary" style={{ marginLeft: 12, width: 300, height: 388, overflow: 'scroll', backgroundColor: '#f5f5f5', padding: 12 }}>
                                            <Typography data-test="execution-title" className={classes.subMainHeading}>Execution Preview</Typography>
                                            {summary.find(item => item.problem) &&
                                                <Notification dataTest="warnings" error={false} text="There are warnings in these results. Please review before executing." />
                                            }
                                            {!summaryComplete &&
                                                <div data-test="summary-info">
                                                    <Typography paragraph variant="body2">When executing an operation the resources selected may not all be updated if there is a conflict between the state of a resource and the update being applied.</Typography>
                                                    <Typography paragraph variant="body2">To assess the impact that the update will have click on Preview and information will be shown here reflecting what will happen.</Typography>
                                                    <Typography paragraph variant="body2">Note that other users may be updating data at this time so results may also be impacted by that even after previewing.</Typography>
                                                </div>
                                            }
                                            {summaryComplete && summary && summary.length > 0 &&
                                                <div>
                                                    {summaryMessages.map((message, index) =>
                                                        <TitledPanel dataTest={"summary-" + index} key={index} margin={index > 0} title={message}>
                                                            <Typography data-test="summary-message" variant="body2" style={{ fontSize: 13, marginBottom: 12 }}>{summary.find(item => item.message === message).action}</Typography>
                                                            {summary.find(item => item.message === message).problem &&
                                                                <Notification dataTest="quality" error={false} text="Executing this update may affect the quality of the data on these resources." />
                                                            }
                                                            {
                                                                summary.length > 200 &&
                                                                <Typography data-test="too-much-summary" paragraph variant="caption">There are too many resources to list all of them. Displaying the first 200 only.</Typography>
                                                            }
                                                            <div data-test="summary-items">
                                                                {summary
                                                                    .filter(item => item.message === message)
                                                                    .map(item => item.resource)
                                                                    .sort((a, b) => {
                                                                        const aData = GS.isLoaded(a, graph) ? GS.data(a, graph) : {};
                                                                        const bData = GS.isLoaded(b, graph) ? GS.data(b, graph) : {};
                                                                        const aLabel = aData.prefLabel && aData.prefLabel[defaultLang] ? aData.prefLabel[defaultLang] : a;
                                                                        const bLabel = bData.prefLabel && bData.prefLabel[defaultLang] ? bData.prefLabel[defaultLang] : b;
                                                                        if (aLabel.toLowerCase() < bLabel.toLowerCase()) return -1;
                                                                        if (aLabel.toLowerCase() > bLabel.toLowerCase()) return 1;
                                                                        return 0;
                                                                    })
                                                                    .slice(0, 200)
                                                                    .map(item =>
                                                                        <ConceptChip
                                                                            key={item}
                                                                            id={item}
                                                                            handleNotAvailable={true}
                                                                            graph={graph}
                                                                            loadOptions={{
                                                                                language: defaultLang
                                                                            }}
                                                                            defaultLang={defaultLang} />
                                                                    )}
                                                            </div>
                                                        </TitledPanel>
                                                    )}
                                                </div>
                                            }
                                            {summaryComplete && (!summary || summary.length === 0) &&
                                                <Typography data-test="all-good" paragraph variant="body2">It seems like everything is good and all resources will be updated.</Typography>
                                            }
                                        </div>

                                    }
                                </div>
                            </form>
                        </DialogContent>
                        <DialogMultiActions onCancel={this.exitEditData} >
                            <SecondaryButton
                                dataTest="summary-button"
                                disabled={processing || invalid || error || previewNotAvailable}
                                onClick={() => this.getSummary()}>Preview</SecondaryButton>
                            <PrimaryButton
                                dataTest="run-change-button"
                                disabled={processing || invalid || error}
                                onClick={() => this.runChange()}>Execute</PrimaryButton>
                        </DialogMultiActions>
                    </Dialog>
                }
            </React.Fragment>
        );
    }
}

EditDataDialog.defaultProps = {
    icon: <BallotIcon />,
    resourceList: [],
    operationAdd: "addValueToConcept",
    operationRemove: "removeValueFromConcept",
    operationReplace: "replaceValuesOnConcept",
    operationRemoveAll: "removeAllValuesFromConcept",
    disabled: false
};

EditDataDialog.propTypes = {
    classes: PropTypes.object,
    disabled: PropTypes.bool,
    resourceList: PropTypes.array,
    schemeIRI: PropTypes.string,
    defaultLang: PropTypes.string.isRequired,
    operationAdd: PropTypes.string,
    operationRemove: PropTypes.string,
    operationReplace: PropTypes.string,
    operationRemoveAll: PropTypes.string,
    graph: PropTypes.string.isRequired
};

export default withStyles(styles)(EditDataDialog);